/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { StrutturaTipoStrutturaFromJSON, StrutturaTipoStrutturaToJSON, } from './StrutturaTipoStruttura';
/**
 * Check if a given object implements the Struttura interface.
 */
export function instanceOfStruttura(value) {
    return true;
}
export function StrutturaFromJSON(json) {
    return StrutturaFromJSONTyped(json, false);
}
export function StrutturaFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'idTipoStruttura': json['idTipoStruttura'] == null ? undefined : StrutturaTipoStrutturaFromJSON(json['idTipoStruttura']),
        'nome': json['nome'] == null ? undefined : json['nome'],
    };
}
export function StrutturaToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'idTipoStruttura': StrutturaTipoStrutturaToJSON(value['idTipoStruttura']),
        'nome': value['nome'],
    };
}
